import { TypesAdressePatient } from '@/enum/AAT.enum';

export class AdressePatient {
	adresseSelected: TypesAdressePatient;
	voie: string;
	codePostal: string;
	ville: string;
	batiment: string;
	escalier: string;
	etage: string;
	appartement: string;
	codeAcces: string;
	telephone: string;

	constructor(
		adresseSelected: TypesAdressePatient = TypesAdressePatient.ADRESSE_VISITE_HABITUELLE,
		voie: string = '',
		codePostal: string = '',
		ville: string = '',
		batiment: string = '',
		escalier: string = '',
		etage: string = '',
		appartement: string = '',
		codeAcces: string = '',
		telephone: string = ''
	) {
		this.adresseSelected = adresseSelected;
		this.voie = voie;
		this.codePostal = codePostal;
		this.ville = ville;
		this.batiment = batiment;
		this.escalier = escalier;
		this.etage = etage;
		this.appartement = appartement;
		this.codeAcces = codeAcces;
		this.telephone = telephone;
	}
}

export interface AdressePatientState {
	adressePatient?: AdressePatient;
}
